// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('product/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/product/productList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getListProduct = createAsyncThunk('product/getListProduct', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/product/productListSystem`, {params})
  return {
    params,
    dataSystem: response.data.Response.items
  }
})

export const getProduct = createAsyncThunk('product/getProduct', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/product/productEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addProduct = createAsyncThunk('product/addProduct', async (CreateProduct, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/product/productCreate`, {
    Request: {
      CreateProduct
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().products.params))
  await dispatch(getAllData())
  return CreateProduct
})

export const updateProduct = createAsyncThunk('product/addProduct', async (UpdateProduct, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/product/productUpdate`, {
    Request: {
      UpdateProduct
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().products.params))
  await dispatch(getAllData())
  return UpdateProduct
})

export const changeStatus = createAsyncThunk('product/changeStatus', async (ChangeStatusProduct, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/product/productChangeStatus`, {
    Request: {
      ChangeStatusProduct
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().products.params))
  return ChangeStatusProduct
})

export const deleteProduct = createAsyncThunk('product/deleteProduct', async (id, { dispatch, getState, rejectWithValue }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/product/productDelete`, {
      Request: {
        DeleteProduct: {
          id
        }
      }
    })
    
    const resData = response.data.Response
    
    if (resData.Code === 1) {
      toast.success('Producto eliminado')
      await dispatch(getData(getState().products.params))
    } else if (!resData.Data) {
      toast.error(resData.Description || 'Error al eliminar el producto')
    }
    
    return resData
    
  } catch (error) {
    if (error?.response?.data?.Response) {
      const errorData = error.response.data.Response
      if (!errorData.Data) {
        toast.error(errorData.Description || 'Error de servidor al eliminar')
      }
      return errorData
    }
    
    toast.error('Error de conexión')
    return rejectWithValue(error.message)
  }
})

export const deleteProductPresentation = createAsyncThunk('product/deleteProductPresentation', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/product/productPresentationDelete/${id}`)
  
  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  await dispatch(getProduct(getState().products.selectedProduct.id))
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'products',
  initialState: {
    dataSystem: [],
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedProduct: [],
    loading: false,
    loadingEdit: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getListProduct.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getListProduct.fulfilled, (state, action) => {
        state.loading = false
        state.dataSystem = action.payload.dataSystem
        state.params = action.payload.params
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.loadingEdit = false
        state.selectedProduct = action.payload
      })
      .addCase(getProduct.pending, (state, action) => {
        state.loadingEdit = true
        state.selectedProduct = action.payload
      })
  }
})

export default appCategoriesSlice.reducer
